export enum MyColors {
	PRIMARY = 'var(--color-my-primary)',
	PRIMARY900 = 'var(--color-my-primary-900)',
	PRIMARY800 = 'var(--color-my-primary-800)',
	PRIMARY700 = 'var(--color-my-primary-700)',
	PRIMARY600 = 'var(--color-my-primary-600)',
	PRIMARY500 = 'var(--color-my-primary-500)',
	PRIMARY400 = 'var(--color-my-primary-400)',
	PRIMARY300 = 'var(--color-my-primary-300)',
	PRIMARY200 = 'var(--color-my-primary-200)',
	PRIMARY100 = 'var(--color-my-primary-100)',
}
